export const LOG_COLUMNS = [
  {
    key: "created_at",
    label: "발생 시각",
    format: "YYYY-MM-DD HH:mm:ss",
    align: "text-left"
  },
  {
    key: "user_id",
    label: "ID",
    align: "text-left"
  },
  {
    key: "user_name",
    label: "유저명",
    align: "text-left"
  },
  {
    key: "role",
    label: "권한",
    align: "text-left"
  },
  {
    key: "message",
    label: "활동 내용",
    align: "text-left"
  },
  {
    key: "ip_address",
    label: "IP",
    align: "text-left"
  }
]
